import { page, type FeatureRoutes } from "@/app/feature";

// The living design reference: every token and component, for the screen work and the owner. Public, so
// it opens without signing in (the preview runs in mock mode).
export const routes: FeatureRoutes = {
  public: [
    { path: "design", lazy: page(() => import("./DesignPage")) },
    // One component alone, for the native apps' visual pipeline (apps/ios/tools/visual).
    { path: "design/specimen", lazy: page(() => import("./SpecimenPage")) },
  ],
};
